export const WORLD_SIZE = 10;
export const TILE_ASPECT_RATIO = 1.1;